import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const styles = {
  paper: {
    margin: 0,
    padding: 0,
    width: '100%',

  },
  container: {
    margin: 0,
    padding: 0,
  },
};

function SimpleDialog(props) {
  const { onClose, openMediaModal, mediaID, mediaURL, classes } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      maxWidth="md"
      direction="rtl"
      scroll="paper"
      repositionOnUpdate={false}
      aria-labelledby="simple-dialog-title"
      open={openMediaModal}
      movieid={mediaID}
      classes={{
        paper: classes.paper,
        container: classes.container,
      }}
      onClose={(e) => {
        handleClose();
      }}
    >
      <FontAwesomeIcon
        icon={faTimes}
        style={{
          fontSize: '2em',
          alignSelf: 'flex-end',
          margin: '5px 10px',
          cursor: 'pointer',
        }}
        onClick={handleClose}
      />
      <div className="ugly modalBody p-1">
        <Grid container>
          <Grid item className="text-center" xs={12}>
            <div className="video-container">
              <iframe 
                width="560" 
                height="315" 
                src={mediaURL} 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; " 
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
}

// ✅ Correctly wrap the component with withStyles
export default withStyles(styles)(SimpleDialog);
